module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"free":"Всегда бесплатный","trialFor":"Бесплатный на","currency":{"RUB":"рублей"},"features":"Возможности","button":{"select":"Выбрать","active":"Используется"},"endless":"единоразово"}}')
  delete Component.options._Ctor
}
